<style>
  div.tabs {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  }

  @media screen and (width < 1200px) {
    div.tabs {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    }
  }
</style>

<div ngDefaultControl>
  <!--
  <div>
    <app-label-input></app-label-input>

  </div> -->

  <div [hidden]="lead != undefined">
    <h1>New lead</h1>

    <div class="flex-container" id="contactInformationContainer">
      <div style="flex: 1">
        <div class="sectionContainer paddedContent containerMargins">
          <h2>Business</h2>

          <div class="column">
            <app-text-input
              [label]="'Name'"
              [required]="true"
              [(ngModel)]="this.business.name"
            ></app-text-input>
          </div>

          <div class="column">
            <app-text-input
              [label]="'Industry'"
              [required]="true"
              [(ngModel)]="this.business.industry"
            ></app-text-input>
          </div>

          <h2>Contact</h2>

          <div class="column">
            <app-text-input
              [label]="'First Name'"
              [required]="true"
              [(ngModel)]="this.contact.firstName"
            ></app-text-input>
          </div>
          <div class="column">
            <app-text-input
              [label]="'Last Name'"
              [required]="true"
              [(ngModel)]="this.contact.lastName"
            ></app-text-input>
          </div>
          <div class="column">
            <app-text-input
              [label]="'Email Address'"
              [type]="inputTextModes.Email"
              [required]="true"
              [(ngModel)]="this.contact.emailAddress"
            ></app-text-input>
          </div>
          <div class="column">
            <app-text-input
              [label]="'Phone'"
              [required]="false"
              [type]="inputTextModes.Phone"
              [(ngModel)]="this.contact.phone"
            ></app-text-input>
          </div>
          <div class="column">
            <app-text-input
              [label]="'Fax'"
              [required]="false"
              [type]="inputTextModes.Phone"
              [(ngModel)]="this.contact.fax"
            ></app-text-input>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-container" id="contactInformationContainer">
      <div style="flex: 1">
        <div class="sectionContainer paddedContent containerMargins">
          <h2>Solution</h2>

          <div class="column">
            <app-multiline-input
              [label]="'Description'"
              [cols]="80"
              [rows]="12"
              [(ngModel)]="this.solution"
            ></app-multiline-input>
          </div>
        </div>
      </div>
    </div>

    <input
      type="button"
      class="button_primary button_var_1"
      value="Create"
      (click)="btnCreateLead_click()"
    />
  </div>

  <div
    [hidden]="lead == undefined"
    style="width: var(--contentWidthComfortable)"
    class="containerMargins"
  >
    <h2>Lead: {{ lead && lead.business ? lead.business.name : '' }}</h2>
    <p>Owner: <i>Tanner T.</i></p>

    <div style="text-align: center">
      <app-lead-progress-bar #progress></app-lead-progress-bar>
    </div>
  </div>

  <div [hidden]="lead == undefined" class="containerMargins width-chunky">
    <div class="tabs">
      <div class="tab" id="tab_businessContainer">
        <div class="content" (click)="selectBookmark('businessContainer')">
          <app-icon [type]="'Location'" [color]="'#ffffff'" />
          <div>Business Info</div>
        </div>
      </div>
      <div class="tab" id="tab_contactsContainer">
        <div class="content" (click)="selectBookmark('contactsContainer')">
          <app-icon [type]="'User'" [color]="'#ffffff'" />
          <div>Contacts</div>
        </div>
      </div>
      <div class="tab" id="tab_solutionContainer">
        <div class="content" (click)="selectBookmark('solutionContainer')">
          <app-icon [type]="'Account'" [color]="'#ffffff'" />
          <div>Solution</div>
        </div>
      </div>
      <div class="tab" id="tab_applicationContainer">
        <div class="content" (click)="selectBookmark('applicationContainer')">
          <app-icon [type]="'Dollar'" [color]="'#ffffff'" />
          <div>Application Setup</div>
        </div>
      </div>
      <div class="tab" id="tab_attachmentsContainer">
        <div class="content" (click)="selectBookmark('attachmentsContainer')">
          <app-icon [type]="'File'" [color]="'#ffffff'" />
          <div>Attachments</div>
        </div>
      </div>
      <div class="tab" id="tab_processingContainer">
        <div class="content" (click)="selectBookmark('processingContainer')">
          <app-icon [type]="'VirtualTerminal'" [color]="'#ffffff'" />
          <div>Processing</div>
        </div>
      </div>
    </div>

    <div id="businessContainer" class="tabContent">
      <div class="sectionContainer containerMargins">
        @if (lead) {
          <div class="paddedContent">
            <div class="formRow">
              <app-text-input
                [label]="'DBA'"
                [style]="'width:250px;'"
                [readonly]="false"
                [required]="true"
                [(ngModel)]="this.lead.dba"
              ></app-text-input>
              <app-text-input
                [label]="'Legal Name'"
                [style]="'width:250px;'"
                [readonly]="false"
                [required]="true"
                [(ngModel)]="this.lead.legalName"
              ></app-text-input>
            </div>
            <div class="formRow">
              <app-text-input
                [label]="'Website'"
                [readonly]="false"
                [required]="true"
              ></app-text-input>
              <app-text-input
                [label]="'DBA Phone'"
                [readonly]="false"
                [required]="true"
              ></app-text-input>
              <app-text-input
                [label]="'DBA Fax'"
                [guidedFormat]="'111-111-1111'"
                [type]="inputTextModes.Phone"
                [readonly]="false"
                [required]="false"
              ></app-text-input>
              <app-text-input
                [label]="'Mobile Phone'"
                [guidedFormat]="'111-111-1111'"
                [type]="inputTextModes.Phone"
                [readonly]="false"
                [required]="false"
              ></app-text-input>
            </div>
            <div class="formSection containerMargins">
              <div class="sectionHeader">Multiple Locations?</div>
              <div class="formRow">
                <app-text-input
                  [label]="'Number of locations'"
                  [type]="inputTextModes.Numeric"
                  [readonly]="false"
                  [required]="false"
                ></app-text-input>
                <app-multiline-input
                  [label]="'Location notes'"
                  [readonly]="false"
                  [required]="false"
                ></app-multiline-input>
              </div>
            </div>
            <div class="formSection containerMargins">
              <div class="sectionHeader">Company information</div>
              <div class="formRow">
                <app-text-input
                  [label]="'Tax ID/EIN'"
                  style="width: 214px"
                  [readonly]="false"
                  [required]="true"
                ></app-text-input>
                <!-- LLC/C Corp/S Corp/etc.-->
                <app-ddl-input
                  [label]="'Legal Business Type'"
                  style="min-width: 200px"
                  [readonly]="false"
                  [required]="true"
                ></app-ddl-input>
                <app-text-input
                  [label]="'Industry'"
                  [readonly]="false"
                  [required]="true"
                  [(ngModel)]="this.lead.industry"
                ></app-text-input>
                <app-text-input
                  [label]="'Primary Business Ops'"
                  [readonly]="false"
                  [required]="false"
                  [(ngModel)]="this.lead.businessType"
                ></app-text-input>
              </div>
              <div class="formRow">
                <app-text-input
                  [label]="'Est. Monthly Rev'"
                  [style]="'width:150px'"
                  [type]="inputTextModes.CurrencyUSD"
                  [readonly]="false"
                  [required]="false"
                  [(ngModel)]="this.lead.monthlyRev"
                ></app-text-input>
                <app-text-input
                  [label]="'Est. Annual Rev'"
                  [style]="'width:150px'"
                  [type]="inputTextModes.CurrencyUSD"
                  [readonly]="false"
                  [required]="false"
                  [(ngModel)]="this.lead.annualRev"
                ></app-text-input>
              </div>
              <div class="formRow">
                <app-ddl-input
                  [label]="'Franchise Brand'"
                  [type]="ddlModes.Brands"
                  [readonly]="false"
                  [required]="false"
                  [(ngModel)]="this.lead.company.franchiseBrand"
                ></app-ddl-input>
                <app-text-input
                  [label]="'Operating Area(s) for DBA'"
                  [readonly]="false"
                  [required]="false"
                  [(ngModel)]="this.lead.company.dbaOperatingAreas"
                ></app-text-input>
                <app-text-input
                  [label]="'Target Open Date'"
                  [type]="inputTextModes.Date"
                  [readonly]="false"
                  [(ngModel)]="this.lead.targetOpenDate"
                  [required]="false"
                ></app-text-input>
              </div>
              <div class="formRow">
                <app-ddl-input
                  [label]="'Country Formed'"
                  [type]="ddlModes.Countries"
                  [readonly]="false"
                  [required]="false"
                  [(ngModel)]="this.lead.company.countryFormed"
                ></app-ddl-input>
                <app-text-input
                  [label]="'Year Established'"
                  [type]="inputTextModes.Numeric"
                  [readonly]="false"
                  [required]="false"
                  [(ngModel)]="this.lead.company.yearEstablished"
                ></app-text-input>
                (months) (years)
              </div>
            </div>
            <div class="formSection containerMargins">
              <div class="sectionHeader">Other address information</div>
              <div class="formRow">
                <app-ddl-input
                  [label]="'Address Type'"
                  [options]="addressOptions"
                  [readonly]="false"
                  [required]="false"
                />
                <app-text-input
                  [label]="'Contact Name'"
                  [readonly]="false"
                  [required]="false"
                ></app-text-input>
                <app-text-input
                  [label]="'Contact Phone'"
                  [readonly]="false"
                  [required]="false"
                ></app-text-input>
              </div>
              <div class="formRow">
                <app-ddl-input
                  [label]="'Country'"
                  [type]="ddlModes.Countries"
                  [(ngModel)]="lead.country"
                  (onChanged)="ddlCountry_change()"
                  [readonly]="false"
                  [required]="false"
                />
              </div>
              <div class="formRow">
                <app-text-input
                  [label]="'Street'"
                  [readonly]="false"
                  [required]="false"
                />
                <app-text-input
                  [label]="'City'"
                  [readonly]="false"
                  [required]="false"
                ></app-text-input>
                <app-ddl-input
                  [label]="'State'"
                  [type]="ddlModes.States"
                  [readonly]="false"
                  [required]="false"
                  #ddlState
                />
                <app-text-input
                  #postalCode
                  [label]="'Postal Code'"
                  [type]="inputTextModes.PostalCodeUS"
                  [readonly]="false"
                  [required]="false"
                ></app-text-input>
              </div>
            </div>
            <div>
              <input
                type="button"
                class="button_secondary button_var_2"
                value="Save"
              />
            </div>
          </div>
        }
      </div>
    </div>

    <div id="contactsContainer" class="tabContent">
      <div class="sectionContainer containerMargins">
        <div class="paddedContent">
          @for (c of lead.contacts; track c) {
            <div class="flex-container">
              <div>
                <app-contact-form
                  [readonly]="true"
                  [contact]="c"
                ></app-contact-form>
              </div>
              <div>
                <input
                  type="button"
                  class="button_secondary button_var_2"
                  value="Edit"
                  (click)="btnEditContact_click(c)"
                />
              </div>
            </div>
          }

          <div class="formRow">
            <input
              type="button"
              class="button_secondary button_var_2"
              value="Add new"
              (click)="btnAddContact_click()"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      id="solutionContainer"
      class="tabContent containerMargins width-chunky"
    >
      @if (lead) {
        <div>
          <app-merchant-solution></app-merchant-solution>
        </div>
      }
    </div>

    <div id="attachmentsContainer" class="tabContent containerMargins">
      <app-merchant-attachments></app-merchant-attachments>
    </div>

    <div id="applicationContainer" class="tabContent">
      <div class="sectionContainer paddedContent containerMargins width-chunky">
        <!-- <div class="formRow">
        <app-ddl-input [label]="'Processing Type'" [options]="processingTypeOptions" [(ngModel)]="selectedProcessingType" [readonly]="false" [required]="true" />
        <input type="button" class="button_primary button_var_2" [disabled]="!selectedProcessingType" value="Create a new application" (click)="btnCreateApplication_click()" />
      </div> -->

        <app-merchant-application
          [type]="'CreditCard'"
        ></app-merchant-application>
      </div>
    </div>

    <div id="processingContainer" class="tabContent">
      <div class="flex-container">
        <div style="flex: 1">
          <div class="sectionContainer paddedContent containerMargins">
            <h2>Processing</h2>

            <div class="formSection">
              <div class="sectionHeader">Customer success</div>

              <div class="formRow">
                <app-text-input
                  [label]="'Onboarding date'"
                  [type]="inputTextModes.Date"
                  [readonly]="false"
                ></app-text-input>
                <app-text-input
                  [label]="'Onboarding Notes'"
                  [readonly]="false"
                ></app-text-input>
              </div>
            </div>

            <div class="formSection">
              <div class="sectionHeader">CCO Enrollment Info</div>

              <div class="formRow">
                <app-text-input
                  [label]="'Item description'"
                  [readonly]="false"
                ></app-text-input>
                <app-text-input
                  [label]="'Item commodity code'"
                  [readonly]="false"
                ></app-text-input>
                <app-text-input
                  [label]="'Zip code'"
                  [type]="inputTextModes.PostalCodeUS"
                  [readonly]="false"
                ></app-text-input>
              </div>
            </div>

            <div class="formSection">
              <div class="sectionHeader">Auth.net login info</div>

              <div class="formRow">
                <app-text-input
                  [label]="'Gateway ID'"
                  [readonly]="false"
                ></app-text-input>
                <app-text-input
                  [label]="'Username'"
                  [readonly]="false"
                ></app-text-input>
                <app-text-input
                  [label]="'Password'"
                  [readonly]="false"
                ></app-text-input>
                <app-text-input
                  [label]="'API Login ID'"
                  [readonly]="false"
                ></app-text-input>
                <app-text-input
                  [label]="'Transaction key'"
                  [readonly]="false"
                ></app-text-input>
                <app-text-input
                  [label]="'Notes'"
                  [readonly]="false"
                ></app-text-input>
              </div>
            </div>

            <div class="formSection">
              <div class="sectionHeader">Merchant Auth.net Logins</div>

              <div class="formRow">
                <app-text-input
                  [label]="'Username'"
                  [readonly]="false"
                ></app-text-input>
                <app-text-input
                  [label]="'Password'"
                  [readonly]="false"
                ></app-text-input>
                <app-text-input
                  [label]="'Notes'"
                  [readonly]="false"
                ></app-text-input>
              </div>
            </div>

            <div class="formSection">
              <div class="sectionHeader">USAePay</div>

              <div class="formRow">
                <app-text-input
                  [label]="'API Key'"
                  [readonly]="false"
                ></app-text-input>
                <app-text-input
                  [label]="'Gateway monthly fee'"
                  [type]="inputTextModes.CurrencyUSD"
                  [readonly]="false"
                ></app-text-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    @if (lead && lead.notes) {
      <div class="sectionContainer paddedContent containerMargins">
        <h2>Notes</h2>
        <div class="column" style="width: 50%">
          <app-multiline-input
            [readonly]="false"
            [rows]="10"
            [style]="'width:100%;'"
            [(ngModel)]="this.lead.notes"
          ></app-multiline-input>
          <br />
          <div style="text-align: right">
            <input
              type="button"
              class="button_secondary button_var_2"
              value="Save"
            />
          </div>
        </div>
      </div>
    }

    <div class="containerMargins">
      <input
        type="button"
        class="button_secondary button_var_2"
        value="Log phone"
        (click)="btnLogPhone_click()"
      />&nbsp;&nbsp;&nbsp;
      <input
        type="button"
        class="button_secondary button_var_2"
        value="Log email"
        (click)="btnLogEmail_click()"
      />&nbsp;&nbsp;&nbsp;
      <!--
    <input type="button" class="button_secondary button_var_2" value="Add notes" (click)="btnAddNotes_click()" />&nbsp;&nbsp;&nbsp;
    --></div>

    <div class="sectionContainer paddedContent containerMargins">
      <h2>History</h2>

      <div class="sectionContainer" style="padding: 5px; margin: 6px 0px">
        11/13/2024 - <b>Phone</b>&nbsp;<i>(Tanner T.)</i> - Talked about our
        services, discussed their needs; scheduled a follow up to dive deeper.
      </div>

      <div class="sectionContainer" style="padding: 5px; margin: 6px 0px">
        11/8/2024 - <b>Email</b>&nbsp;<i>(Tanner T.) </i> - Introduced Swipesum,
        asked for a call
      </div>

      <div class="sectionContainer" style="padding: 5px; margin: 6px 0px">
        11/8/2024 - <b>Phone Call</b>&nbsp;<i>(Tanner T.) </i> - No response,
        left a vm
      </div>

      <div class="sectionContainer" style="padding: 5px; margin: 6px 0px">
        11/3/2024 - <b>Lead Created</b>&nbsp;<i>(Tanner T.) </i>
      </div>
    </div>
  </div>
</div>
